"use client";

import { c as _c } from "react/compiler-runtime";
import { RiFlashlightLine } from "react-icons/ri";
import { Button } from "@/components/ui";
import { useSequences } from "./context";
interface TriggerProps {
  /** Open the list view. Only invoked when there is at least one sequence. */
  onShowList: () => void;
  /**
   * Start authoring a new sequence. The parent should set up `editingKey` and
   * navigate to the editor — the trigger never mutates drafts itself.
   */
  onCreate: () => void;
}

/**
 * Detail-panel entry point. Shows the count of sequences as a button; click
 * to enter the list view (Panel). In the empty state, becomes an "Add
 * sequence" affordance that jumps straight to the editor (skipping the empty
 * list — see rule #3 in the surrounding surface).
 */
export function Trigger(t0) {
  const $ = _c(11);
  const {
    onShowList,
    onCreate
  } = t0;
  const {
    state: t1,
    meta: t2
  } = useSequences();
  const {
    drafts
  } = t1;
  const {
    readOnly
  } = t2;
  const count = drafts.length;
  if (count === 0 && readOnly) {
    return null;
  }
  if (count === 0) {
    let t3;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <RiFlashlightLine size={12} className="text-status-warning-text" />;
      $[0] = t3;
    } else {
      t3 = $[0];
    }
    let t4;
    if ($[1] !== onCreate) {
      t4 = <Button variant="secondary" onClick={onCreate} className="w-full justify-center" icon={t3} size="sm">Add a Sequence</Button>;
      $[1] = onCreate;
      $[2] = t4;
    } else {
      t4 = $[2];
    }
    return t4;
  }
  const t3 = `View ${count} Message${count === 1 ? "" : "s"}`;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <RiFlashlightLine size={12} className="text-status-warning-text" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = count === 1 ? "" : "s";
  let t6;
  if ($[4] !== t5) {
    t6 = <span>{t5}</span>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== count || $[7] !== onShowList || $[8] !== t3 || $[9] !== t6) {
    t7 = <Button variant="secondary" onClick={onShowList} aria-label={t3} className="w-full justify-start" size="sm" icon={t4}>View {count} Message{t6}</Button>;
    $[6] = count;
    $[7] = onShowList;
    $[8] = t3;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
}